import { createIcons, Cuboid } from "lucide";

class AppEmptyState extends HTMLElement {
  connectedCallback() {
    const title = this.getAttribute("title") || "Módulo Indisponível";
    const message = this.getAttribute("message") || "Módulo será disponibilizado em etapa posterior.";

    this.innerHTML = `
      <div class="empty-state">
        <div class="empty-state-icon">
          <i data-lucide="cuboid"></i>
        </div>
        <div class="empty-state-title">${title}</div>
        <div class="empty-state-desc">${message}</div>
      </div>
    `;

    createIcons({
      icons: { Cuboid },
      nameAttr: "data-lucide",
      root: this
    });
  }
}

if (!customElements.get("app-empty-state")) {
  customElements.define("app-empty-state", AppEmptyState);
}
